<template>
  <div class="cc-carrier" v-if="display" @click="setCarrier(carrier)">
    <div class="cc-carrier__selector">
      <div class="cc-selector cc-selector--medium cc-selector--radio" v-bind:class="{'cc-active': selected}"></div>
    </div>
    <div class="cc-carrier__thumbnail" v-if="carrier.img">
      <img :src="carrier.img" :alt="carrier.name" class="cc-carrier__image">
    </div>
    <div class="cc-carrier__information" v-bind:class="{'cc-thumbnail-exists': carrier.img}">
      <div class="cc-carrier__title cc-title cc-title--carrier">{{ carrier.name }}</div>
      <div class="cc-carrier__subtitle cc-subtitle cc-subtitle--carrier">{{ carrier.delay }}</div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'packetery'">
        <div class="cc-carrier__packetery-branch" v-if="packeteryId">{{ packeteryBranchName }}</div>
        <button class="cc-carrier__packetery-link" @click.stop="showPacketeryWidget(carrier)">{{ packeteryId ? translations['Change'] : translations['Select branch'] }}</button>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'shaim_glsparcelshop'">
        <gls-parcel-shop :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'shaim_dpdparcelshop'">
        <dpd-parcel-shop :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'shaim_ulozenka'">
        <wedo-parcel-shop :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'shaim_balikovna'">
        <shaim-balikovna :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'shaim_baliknapostu'">
        <shaim-balik-na-postu :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'shaim_zasilkovna_widget'">
        <div class="cc-carrier__packetery-branch" v-if="shaim_zasilkovna_widget.id">{{ shaim_zasilkovna_widget.name }}</div>
        <button class="btn btn-primary" @click.stop="showShaimZasilkovnaWidget(carrier)">{{ shaim_zasilkovna_widget.id ? translations['Change'] : translations['Select branch'] }}</button>
      </div>
      <div class="cc-carrier__packetery" v-if="carrier.module === 'cofiscztoptrans'">
        <cofiscz-toptrans :carrier="carrier" :selectedCarrier="currentCarrier" @priceLoadingStart="priceLoadingStart" @priceLoadingDone="priceLoadingDone" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
      <div class="cc-carrier__packetery" v-if="showPickupDate">
        <pickup-date :carrier="carrier" :selectedCarrier="currentCarrier" @selectCarrier="setCarrier" @closeWithoutParcelShop="unsetCarrier"/>
      </div>
    </div>
    <div class="cc-carrier__prices">
      <div class="cc-price cc-price--carrier">{{ price }}</div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import GlsParcelShop from "@/components/Store919/GlsParcelShop";
import DpdParcelShop from "@/components/Store919/DpdParcelShop";
import WedoParcelShop from "@/components/Store919/WedoParcelShop";
import ShaimBalikovna from "@/components/_common/modules/shaim_balikovna/ShaimBalikovna";
import ShaimBalikNaPostu from "@/components/_common/modules/shaim_baliknapostu/ShaimBalikNaPostu";
import PickupDate from "@/components/_common/PickupDate/PickupDate";
import CofisczToptrans from "@/components/_common/modules/cofiscz_toptrans/CofisczToptrans";

export default {
  components: {
    PickupDate,
    ShaimBalikNaPostu,
    ShaimBalikovna,
    GlsParcelShop,
    DpdParcelShop,
    WedoParcelShop,
    CofisczToptrans
  },
  data () {
    return {
      customPriceText: '',
    };
  },
  computed: {
    ...mapState({
      translations: state => state.translations,
      selectedCarrier: state => state.selectedCarrier,
      currentCarrier: state => state.currentCarrier,
      user: state => state.user,
      packetery: state => state.packetery,
      packetery_v213: state => state.packetery_v213,
      useVat: state => state.config.use_vat,
      shaim_zasilkovna_widget: state => state.shaim_zasilkovna_widget,
      config: state => state.config,
    }),
    packeteryId () {
      const version = this.carrier.extra.version.replaceAll('.', '');
      return version >= 213 ? this.packetery_v213.id : this.packetery.id;
    },
    packeteryBranchName () {
      const version = this.carrier.extra.version.replaceAll('.', '');
      if (version >= 213) {
        return this.packetery_v213.name;
      } else {
        return this.packetery.name;
      }
    },
    display: function () {
      return !this.selectedCarrier || this.selected;
    },
    selected: function () {
      return this.carrier.id_carrier === this.selectedCarrier;
    },
    price: function () {
      if (this.carrier.module === 'cofiscztoptrans') {
        if (this.customPriceText != '') {
          return this.customPriceText;
        }
      	if (this.carrier.free)  {
      		return this.translations['Select adress'];
      	}
      }
      if (this.carrier.free) {
        return this.translations['Free'];
      }
      if (this.useVat) {
        return this.carrier.formattedPrices.price;
      }
      return this.carrier.formattedPrices.price_without_tax;
    },
    pickupInStore: function () {
      return this.currentCarrier && this.currentCarrier.pickupInStore;
    },
    showPickupDate: function () {
      return this.carrier.extra.show_pickup_date
    }
  },
  methods: {
    priceLoadingStart: function () {
      this.customPriceText = this.translations['Loading price'];
    },
    priceLoadingDone: function () {
      this.customPriceText = '';
    },
    unsetCarrier: function () {
      this.$store.dispatch('SELECT_CARRIER', null);
      this.$store.dispatch('SELECT_PAYMENT', null);
      this.$store.commit('SET_LOCK_DELIVERY_POSTAL_CODE',false)
    },
    setCarrier: function (carrier) {
      const that = this;

      this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(function () {
        if (carrier.module === 'packetery') {
          that.showPacketeryWidget(carrier);
        }
        if (carrier.module === 'shaim_zasilkovna_widget') {
          that.showShaimZasilkovnaWidget(carrier);
        }
        if (carrier.module === 'cofiscztoptrans') {
          that.$store.commit('SET_LOCK_DELIVERY_POSTAL_CODE',true)
        }

        if (window.innerWidth < 1200) {
          document.querySelector('.cc-carriers').scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        } else {
          document.querySelector('.cc-theme').scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    },
    getPacketery: function () {
      const filtered = this.carriers.filter(item => item.module === 'packetery');

      if (filtered.length === 1) {
        return filtered[0];
      }

      return null;
    },
    showPacketeryWidget: function (carrier) {
      const countries = this.config.countries
          .filter(item => parseInt(item.id) === parseInt(this.user.deliveryAddress.country))
          .map(item => item.iso.toLowerCase())
          .join(',');
      const version = carrier.extra.version.replaceAll('.', '');
      if (version >= 213) {
        Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
          if (item === null) {
            this.unsetCarrier();
            return this.$store.commit('SET_PACKETERY_V213', {
              id: null,
              name: null,
              currency: null,
              pickupPointType: null,
              carrierId: null,
              carrierPickupPointId: null,
              prestashopCarrierId: null,
            });
          }

          this.$store.dispatch('UPDATE_PACKETERY_V213', {
            id: item.id,
            name: item.name,
            currency: item.currency,
            pickupPointType: item.pickupPointType,
            carrierId: item.carrierId,
            carrierPickupPointId: item.carrierPickupPointId,
            prestashopCarrierId: carrier.id,
          }).then(() => {
            this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(() => {
              document.querySelector('.cc-carriers').scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            });
          });
        }, {
          country: countries,
        });
      } else {
        Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
          if (item === null) {
            this.unsetCarrier();
            return this.$store.commit('SET_PACKETERY', {
              id: null,
              name: null,
              currency: null,
            });
          }

          this.$store.dispatch('UPDATE_PACKETERY', {
            id: item.id,
            name: item.name,
            currency: item.currency,
          }).then(() => {
            this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(() => {
              document.querySelector('.cc-carriers').scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
            });
          });
        });
      }
    },
    showShaimZasilkovnaWidget: function (carrier) {
      const countries = this.config.countries
          .filter(item => parseInt(item.id) === parseInt(this.user.deliveryAddress.country))
          .map(item => item.iso.toLowerCase())
          .join(',');
      Packeta.Widget.pick(carrier.extra.apiKey, (item) => {
        if (item === null) {
          this.unsetCarrier();
          return this.$store.commit('SET_SHAIM_ZASILKOVNA_WIDGET', {
            id: null,
            name: null,
            currency: null
          });
        }
        item.secret_key = carrier.extra.secret_key;
        this.$store.dispatch('UPDATE_SHAIM_ZASILKOVNA_WIDGET', item)
            .then(() => {
              this.$store.dispatch('SELECT_CARRIER', carrier.id_carrier).then(() => {
                document.querySelector('.cc-carriers').scrollIntoView({
                  behavior: "smooth",
                  block: "start",
                });
              });
            });
      }, {
        country: countries,
      });
    }
  },
  mounted() {
    const loadPacketeryScript = () => {
      if (this.carrier.module !== 'packetery' || this.carrier.module !== 'shaim_zasilkovna_widget') {
        return;
      }
      const version = this.carrier.extra.version.replaceAll('.', '');
      const packeteryApi = document.createElement('script');
      if (version >= 213) {
        packeteryApi.setAttribute('src', 'https://widget.packeta.com/v6/www/js/library.js');
      } else {
        packeteryApi.setAttribute('src', 'https://widget.packeta.com/www/js/library.js');
      }
      document.head.appendChild(packeteryApi);
    };

    loadPacketeryScript();
  },
  props: [
    'carrier',
  ],
};
</script>

<style lang="scss" scoped="scoped">
@import "./scss/components/carrier";
</style>
